// 9fbef606107a605d69c0edbcd8029e5d
import { css, keyframes } from 'styled-components';

const smLoading = keyframes`
  to {
    background-position:
      500px 0,  // animation
      0 0,      // image
      0 222px,  // badge
      0 260px,  // title
      0 300px,  // swatches
      0 350px,  // add to bag
      0 0       // card
    ;
  }
`;

const mdLoading = keyframes`
  to {
    background-position:
      500px 0,  // animation
      0 0,      // image
      0 289px,  // badge
      0 340px,  // title
      0 389px,  // swatches
      0 444px,  // add to bag
      0 0       // card
    ;
  }
`;

const lgLoading = keyframes`
  to {
    background-position:
      500px 0,  // animation
      0 0,      // image
      0 363px,  // badge
      0 416px,  // title
      0 462px,  // swatches
      0 524px,  // add to bag
      0 0       // card
    ;
  }
`;

const style = css`
  .product-tile {
    height: 382px;
    width: calc(50% - ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS});
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 10px;
    margin: 0 0 6px 0;
    background-clip: content-box;

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0)
        ),
        // animation
        linear-gradient(#d8d8d8 200px, transparent 0),
        // image
        linear-gradient(#d8d8d8 18px, transparent 0),
        // badge
        linear-gradient(#d8d8d8 16px, transparent 0),
        // title
        linear-gradient(#d8d8d8 15px, transparent 0),
        // swatches
        linear-gradient(#d8d8d8 32px, transparent 0),
        // add to bag
        linear-gradient(white, transparent 0) // card
;
      background-size: 100% 100%, 100% 200px, 40px 18px, 100% 16px, 100% 15px, 100% 32px, 100% 100%;
      background-position: -500px 0, 0 0, 0 222px, 0 260px, 0 300px, 0 350px, 0 0;
      background-repeat: no-repeat;
      animation: ${smLoading} 0.5s ease-in-out infinite;
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      height: 486px;
      width: calc(33.33% - ${(props) => props.theme.spacing.LAYOUT_SPACING.LRG});
      margin: 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.LRG} 0;
      padding: 12px ${(props) => props.theme.spacing.LAYOUT_SPACING.SM};

      &::after {
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0.6),
            rgba(255, 255, 255, 0)
          ),
          linear-gradient(#d8d8d8 257px, transparent 0),
          linear-gradient(#d8d8d8 24px, transparent 0), linear-gradient(#d8d8d8 18px, transparent 0),
          linear-gradient(#d8d8d8 15px, transparent 0), linear-gradient(#d8d8d8 42px, transparent 0),
          linear-gradient(white, transparent 0);

        background-size: 100% 100%, 100% 257px, 50px 24px, 100% 18px, 100% 15px, 100% 42px,
          100% 100%;

        background-position: -500px 0, 0 0, 0 289px, 0 340px, 0 389px, 0 444px, 0 0;
        animation: ${mdLoading} 0.5s ease-in-out infinite;
      }
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      height: 576px;
      width: calc(25% - 42px);
      margin: 0 0 19px 0;
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 21px;

      &::after {
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0.6),
            rgba(255, 255, 255, 0)
          ),
          linear-gradient(#d8d8d8 344px, transparent 0),
          linear-gradient(#d8d8d8 27px, transparent 0), linear-gradient(#d8d8d8 19px, transparent 0),
          linear-gradient(#d8d8d8 20px, transparent 0), linear-gradient(#d8d8d8 52px, transparent 0),
          linear-gradient(white, transparent 0);

        background-size: 100% 100%, 100% 344px, 53px 27px, 100% 19px, 100% 20px, 100% 52px,
          100% 100%;

        background-position: -500px 0, 0 0, 0 363px, 0 416px, 0 462px, 0 524px, 0 0;
        animation: ${lgLoading} 0.5s ease-in-out infinite;
      }
    }
  }
  ${(props) => props.overrideStyle || ''}
`;

export default style;
